export default __webpack_public_path__ + "static/media/7-deers.93827857.png";